import { render, staticRenderFns } from "./CVOfferStatusErrorForm.vue?vue&type=template&id=c023c038"
import script from "./CVOfferStatusErrorForm.vue?vue&type=script&lang=js"
export * from "./CVOfferStatusErrorForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports